
import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Bot, Brain } from 'lucide-react';
import { useEnhancedAIModel } from './enhanced-ai/useEnhancedAIModel';
import { FeaturesGrid } from './enhanced-ai/FeaturesGrid';
import { AnalysisStatus } from './enhanced-ai/AnalysisStatus';
import { type EnhancedAIModelButtonProps } from './enhanced-ai/types';

export function EnhancedAIModelButton({ onModelGenerated }: EnhancedAIModelButtonProps) {
  const { isRunning, analysisStage, runEnhancedFinancialModel } = useEnhancedAIModel(onModelGenerated);

  return (
    <Card className="border-2 border-blue-200 bg-gradient-to-br from-blue-50 to-indigo-50">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Brain className="h-5 w-5 text-blue-600" />
          Enhanced AI Financial Model
          <Badge variant="outline" className="ml-2">Deep Learning</Badge>
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <FeaturesGrid />

        <AnalysisStatus analysisStage={analysisStage} />

        <Button
          onClick={runEnhancedFinancialModel}
          disabled={isRunning}
          className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700"
          size="lg"
        >
          {isRunning ? (
            <>
              <Brain className="h-4 w-4 mr-2 animate-pulse" />
              Running Enhanced Analysis...
            </>
          ) : (
            <>
              <Bot className="h-4 w-4 mr-2" />
              Run Enhanced AI Model
            </>
          )}
        </Button>
      </CardContent>
    </Card>
  );
}
